// extracted by mini-css-extract-plugin
export default {"successStepContainer":"ZTSwtuBLnVamTVRH1CdJ","headerContainer":"y1nXmeOOpzt1XoJygWtX","imageContainer":"KPe9sK4xP76Y4z2fzxvh"};